import { render, staticRenderFns } from "./GoodsListCom.vue?vue&type=template&id=67b47712&scoped=true&"
import script from "./GoodsListCom.vue?vue&type=script&lang=js&"
export * from "./GoodsListCom.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListCom.vue?vue&type=style&index=0&id=67b47712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b47712",
  null
  
)

export default component.exports